import { Component, OnDestroy, OnInit } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { rubberBand } from 'ng-animate';
import { ConfettiService } from '../../shared/libraries/confetti.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  bounce: any;
  
  constructor(
    private route: Router,
    private confetti: ConfettiService
  ) { }

  ngOnInit() {
  }

  login(event) {
    this.route.navigateByUrl('/login');
  }

  onRedirect(e) {
    this.confetti.showConfettiSide();
  }

  ngOnDestroy() {
  }
}
